// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lexical-editor-wrapper {
    border: 1px solid #cccccc;
    border-radius: 4px;
    background: #ffffff;
}

.lexical-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    padding: 4px 6px;
    border-bottom: 1px solid #cccccc;
    background: #f5f5f5;
    border-radius: 4px 4px 0 0;
}

.lexical-toolbar-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    padding: 0;
    border: 1px solid transparent;
    border-radius: 3px;
    background: transparent;
    cursor: pointer;
    font-size: 13px;
    color: #333333;
    line-height: 1;
}

.lexical-toolbar-btn:hover {
    background: #e0e0e0;
    border-color: #bbbbbb;
}

.lexical-toolbar-btn.active {
    background: #d0d8e8;
    border-color: #9aabcc;
}

.lexical-toolbar-sep {
    width: 1px;
    background: #cccccc;
    margin: 2px 3px;
    align-self: stretch;
}

.lexical-editable {
    padding: 6px 8px;
    outline: none;
    overflow-y: auto;
    font-size: 13px;
    line-height: 1.5;
    color: #333333;
}

.lexical-editable p {
    font-size: 14px !important;
    margin: 0 0 4px 0;
}

.lexical-editable ul,
.lexical-editable ol {
    margin: 0 0 4px 0;
    padding-left: 20px;
}

.lexical-editable li {
    margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./_devapp/UI/LexicalRichTextEditor.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".lexical-editor-wrapper {\n    border: 1px solid #cccccc;\n    border-radius: 4px;\n    background: #ffffff;\n}\n\n.lexical-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2px;\n    padding: 4px 6px;\n    border-bottom: 1px solid #cccccc;\n    background: #f5f5f5;\n    border-radius: 4px 4px 0 0;\n}\n\n.lexical-toolbar-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    border: 1px solid transparent;\n    border-radius: 3px;\n    background: transparent;\n    cursor: pointer;\n    font-size: 13px;\n    color: #333333;\n    line-height: 1;\n}\n\n.lexical-toolbar-btn:hover {\n    background: #e0e0e0;\n    border-color: #bbbbbb;\n}\n\n.lexical-toolbar-btn.active {\n    background: #d0d8e8;\n    border-color: #9aabcc;\n}\n\n.lexical-toolbar-sep {\n    width: 1px;\n    background: #cccccc;\n    margin: 2px 3px;\n    align-self: stretch;\n}\n\n.lexical-editable {\n    padding: 6px 8px;\n    outline: none;\n    overflow-y: auto;\n    font-size: 13px;\n    line-height: 1.5;\n    color: #333333;\n}\n\n.lexical-editable p {\n    font-size: 14px !important;\n    margin: 0 0 4px 0;\n}\n\n.lexical-editable ul,\n.lexical-editable ol {\n    margin: 0 0 4px 0;\n    padding-left: 20px;\n}\n\n.lexical-editable li {\n    margin-bottom: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
